var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccessMessage = function SvgSuccessMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30301 13L1.33301 15.3333V2.99998C1.33301 2.82317 1.40325 2.6536 1.52827 2.52858C1.65329 2.40355 1.82286 2.33331 1.99967 2.33331H13.9997C14.1765 2.33331 14.3461 2.40355 14.4711 2.52858C14.5961 2.6536 14.6663 2.82317 14.6663 2.99998V12.3333C14.6663 12.5101 14.5961 12.6797 14.4711 12.8047C14.3461 12.9297 14.1765 13 13.9997 13H4.30301ZM3.84167 11.6666H13.333V3.66665H2.66634V12.59L3.84167 11.6666ZM7.52834 8.41398L10.357 5.58598L11.2997 6.52865L7.52834 10.3L4.93501 7.70665L5.87834 6.76398L7.52834 8.41398V8.41398Z"
  })));
};
export default SvgSuccessMessage;